import { css, styled } from '@mui/material';

export const StyledRadioContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledListItem = styled('div')`
  display: flex;
  word-break: break-word;
`;
